import apiM from '../GlobalEnv'


export const weeklyTrans = data => ({
    'type': 'GET_WEEKLY',
    'load': data
})

export const monthTrans = data => ({
    'type': 'GET_MONTH',
    'load': data
})

export const dailyTrans = data => ({
    'type': 'GET_DAILY',
    'load': data
})

export const getMonthDb = () => {
    return async dispatch => {
   const api = apiM + `/finance/${sessionStorage.getItem('mail')}/getMonthly/month`
   
   try {
    let res = await fetch(api)

    let resData = res.json()
     
    let dData = await resData
    // console.log(dData)

    dispatch(monthTrans(dData))

  
}

   catch(e) {
  console.info(e)
   }

    }
}

export const getWeeklyDb = () => {
    return async dispatch => {
        dispatch({type: "DAILY_PROGRESS", load: {progress: "progress"}})

   const api =apiM +  `/finance/${sessionStorage.getItem('mail')}/getweekly/week`
 
   try {
    let res = await fetch(api)

    let resData = res.json()
     
    let dData = await resData

    if(dData === [] || dData.length < 1) {
        dispatch({type: "DAILY_INFO", load: {progress: "Empty"}})
    }
    else{ 
        dispatch(weeklyTrans(dData))

        dispatch({type: "DAILY_PROGRESS", load: {progress: "complete"}})
    }

  
}

   catch(e) {
    dispatch({type: "DAILY_PROGRESS", load: false})
   return e
   }

     }
}

export const getDailyDb = () => {
     return async dispatch => {
         dispatch({type: "DAILY_PROGRESS", load: {progress: "progress"}})
        const api =apiM + `/finance/${sessionStorage.getItem('mail')}/getDaily/day`

        try {
            let res = await fetch(api)
            
            let resData = res.json()

            //  console.log(resData)
            let {dailyRecs} = await resData
            
            if(dailyRecs === [] || dailyRecs.length < 1) {
                dispatch({type: "DAILY_INFO", load: {progress: "Empty"}})
            }
            else {
                dispatch(dailyTrans(dailyRecs))
                
                dispatch({type: "DAILY_PROGRESS", load: {progress: "complete"}})
            }

        } 
        catch (error) {
            dispatch({type: "DAILY_PROGRESS", load: false})
            return error
        }
    }
}

